/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * A permission that the application requests on another account.
 */
export const ApplicationScope = {
  AccountsRead: "accounts.read",
  AccountsWrite: "accounts.write",
  AnalyticsRead: "analytics.read",
  ApplePayMerchantRead: "apple-pay-merchant.read",
  ApplePayMerchantWrite: "apple-pay-merchant.write",
  ApplePayRead: "apple-pay.read",
  ApplePayWrite: "apple-pay.write",
  BankAccountsRead: "bank-accounts.read",
  BankAccountsWrite: "bank-accounts.write",
  CapabilitiesRead: "capabilities.read",
  CapabilitiesWrite: "capabilities.write",
  CardsRead: "cards.read",
  CardsWrite: "cards.write",
  DocumentsRead: "documents.read",
  DocumentsWrite: "documents.write",
  FedRead: "fed.read",
  FilesRead: "files.read",
  FilesWrite: "files.write",
  IssuedCardsRead: "issued-cards.read",
  IssuedCardsWrite: "issued-cards.write",
  IssuedCardsReadSecure: "issued-cards.read-secure",
  PaymentMethodsRead: "payment-methods.read",
  PingRead: "ping.read",
  ProfileEnrichmentRead: "profile-enrichment.read",
  ProfileRead: "profile.read",
  ProfileWrite: "profile.write",
  ProfileDisconnect: "profile.disconnect",
  RepresentativesRead: "representatives.read",
  RepresentativesWrite: "representatives.write",
  TransfersRead: "transfers.read",
  TransfersWrite: "transfers.write",
  WalletsRead: "wallets.read",
} as const;
/**
 * A permission that the application requests on another account.
 */
export type ApplicationScope = ClosedEnum<typeof ApplicationScope>;

/** @internal */
export const ApplicationScope$inboundSchema: z.ZodNativeEnum<
  typeof ApplicationScope
> = z.nativeEnum(ApplicationScope);
/** @internal */
export const ApplicationScope$outboundSchema: z.ZodNativeEnum<
  typeof ApplicationScope
> = ApplicationScope$inboundSchema;
